/** Minimal inline-SVG icon set matching the legacy panel's line-icon style. */
const PATHS: Record<string, string> = {
  mail: 'M4 4h16v16H4z M22 6l-10 7L2 6',
  check: 'M9 12l2 2 4-4 M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  clock: 'M12 6v6l4 2 M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  dollar: 'M12 1v22 M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6',
  users: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8 M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18z M3 12h18 M12 3a15 15 0 010 18 15 15 0 010-18z',
  ticket: 'M3 9V7a2 2 0 012-2h14a2 2 0 012 2v2a2 2 0 000 6v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 000-6z M12 5v14',
  play: 'M21 12a9 9 0 11-18 0 9 9 0 0118 0z M10 8l6 4-6 4V8z',
  tag: 'M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z M7 7h.01',
  calendar: 'M3 4h18v18H3z M16 2v4 M8 2v4 M3 10h18',
  download: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4 M7 10l5 5 5-5 M12 15V3',
  chart: 'M3 3v18h18 M18 17V9 M13 17V5 M8 17v-3',
  alert: 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z M12 9v4 M12 17h.01',
  trending: 'M23 6l-9.5 9.5-5-5L1 18 M17 6h6v6',
  chat: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
  eye: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 15a3 3 0 100-6 3 3 0 000 6z',
  pencil: 'M17 3a2.85 2.85 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z',
  trash: 'M3 6h18 M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6 M10 11v6 M14 11v6 M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2',
  paperclip: 'M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l8.57-8.57A4 4 0 1118 8.84l-8.59 8.57a2 2 0 01-2.83-2.83l8.49-8.48',
  copy: 'M9 9h13v13H9z M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1',
};

const TINTS: Record<string, string> = {
  purple: 'var(--color-status-info-fg)', green: 'var(--color-status-success-accent)',
  amber: 'var(--color-status-warning-accent)', gray: 'var(--color-text-tertiary)',
};

export function Icon({ name, size = 18 }: { name: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {PATHS[name]?.split(' M').map((seg, i) => <path key={i} d={(i ? 'M' : '') + seg} />)}
    </svg>
  );
}

export function StatCard({ icon, tint = 'purple', value, label, sub }:
  { icon: string; tint?: keyof typeof TINTS; value: React.ReactNode; label: string; sub?: string }) {
  return (
    <div className="statcard">
      <div className="statcard-icon" style={{ color: TINTS[tint] }}><Icon name={icon} /></div>
      <div className="statcard-value">{value}</div>
      <div className="statcard-label">{label}</div>
      {sub && <div className="statcard-sub">{sub}</div>}
    </div>
  );
}
